<template>
    <Modal :isOpen="props.isOpen" @close="emit('close')">
        <template #title>
            <h2 class="text-lg font-medium">How we keep your data safe</h2>
        </template>
        <template #content>
            <Security />
        </template>
        <template #footer>
            <footer class="flex justify-end items-center">
                <button @click="emit('close')" class="btn btn-primary">
                    Close
                </button>
            </footer>
        </template>
    </Modal>
</template>

<script setup>
import Modal from '@/components/ui/modal/ui-modal.vue';
import Security from '@/components/security/index.vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);
</script>
